import {
  HiOutlineLocationMarker,
  HiOutlineMail,
  HiOutlinePhone,
} from "react-icons/hi";

import { FaRegCopyright } from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "Assets/ayozat_logo.svg";
import { RouteName } from "constant/routeNames";
import { AiFillHeart } from "react-icons/ai";
import CustomPagesServices from "services/custompages/CustomPagesServices";
import { useEffect, useState } from "react";
import GeneralServices from "services/General/GeneralServices";
import { FooterSocialMedia } from "constant/FooterSocialMedia";
import FooterResourcesLink from "./Footer/FooterResourcesLink";

function Footer() {
  const [customPage, setCustomPage] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [socialLinks, setSocialLinks] = useState<any>();
  const enabled = localStorage.getItem("ppv_enabled");
  const blogEnabled = localStorage.getItem("blog_enabled");

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      CustomPagesServices.getAllCustomPages()
        .then((res) => {
          const titles: any[] = res?.map((page: any) => page.title);
          setCustomPage(titles);
        })
        .catch((e) => {});
      setIsLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    GeneralServices.getAllConfigData()
      .then((res) => {
        const filteredData = res.data.filter((item: any) => {
          return FooterSocialMedia.some(
            (socialMedia) =>
              socialMedia.title === item.title && item.value !== null
          );
        });
        setSocialLinks(filteredData);
      })
      .catch((e) => {});
  }, []);

  const openInNewWindow = (url: any) => {
    const windowFeatures =
      "width=1000,height=700,left=100,top=100,resizable=yes,scrollbars=yes,status=yes";
    window.open(url, "_blank", windowFeatures);
  };

  return (
    // footer section
    <div className="mx-auto w-[80%] max-sm:text-[20px]">
      <div className="white-text mb-5 mt-8 grid grid-cols-1 gap-y-8 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
        {/* section 1 */}
        <div className="col-span-2 mb-6 max-sm:col-span-1">
          <Link to="/">
            <div className="w-32">
              <img src={Logo} alt="logo" className="w-full" />
            </div>
          </Link>
          <p className="gray-text mb-5 mt-3 w-[60%] cursor-default text-xs leading-relaxed sm:text-sm max-sm:w-full max-sm:text-[13px]">
            Stream Movies, Series, Live TV, Music, Radio & Podcasts plus Live
            Pay-Per-View Events. Watch on AYOZAT STREAM. Your Entertainment Hub!
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            {socialLinks &&
              socialLinks.map((link: any, i: number) => {
                const socialMedia = FooterSocialMedia.find(
                  (media) => media.title === link.title
                );

                if (socialMedia) {
                  const IconComponent = socialMedia.icon;
                  return (
                    <a
                      href={link.value}
                      target="_blank"
                      rel="noreferrer"
                      key={i}
                      className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[16px] text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-[var(--red)] hover:bg-[var(--red)] hover:text-white hover:shadow-lg hover:shadow-[var(--red)]/30"
                    >
                      <IconComponent />
                    </a>
                  );
                }

                return null;
              })}
          </div>
        </div>

        {/* Resources */}
        <div className="mb-6 text-xs sm:text-sm max-sm:text-[13px]">
          <h2 className="mb-6 cursor-default text-[15px] font-semibold text-white">
            Resources
          </h2>
          <div className="gray-text space-y-1">
            <FooterResourcesLink
              text={"Download Apps"}
              route={RouteName.Apps}
            />
            <FooterResourcesLink
              text={"Why PayPerView"}
              route={RouteName.PPvLandingPage}
            />
            <FooterResourcesLink
              text={"All TV Channels"}
              route={RouteName.SeeAllChannelsRoute.replace(":slug", "all")}
            />
            <FooterResourcesLink
              text={"Watch Movies"}
              route={RouteName.SeeAllMoviesRoute}
            />
            <FooterResourcesLink
              text={"Watch TV Series"}
              route={RouteName.SeeAllSeriesRoute}
            />
            <FooterResourcesLink
              text={"Listen to Music"}
              route={RouteName.SeeAllAlbumsRoute}
            />
            <FooterResourcesLink
              text={"Listen to Podcasts"}
              route={RouteName.SeeAllNewPodcastRoute}
            />
            <FooterResourcesLink
              text={"Listen to Radio"}
              route={RouteName.SeeAllMightLikeRoute}
            />
            {blogEnabled === "1" && (
              <FooterResourcesLink text={"Blogs"} route={RouteName.BlogRoute} />
            )}
            {enabled === "1" && (
              <FooterResourcesLink
                text={"Watch PPV Events"}
                route={RouteName.PayPerView.replace("/*", "")}
              />
            )}
          </div>
        </div>

        {/* Quick Links */}
        <div className="mb-6 text-xs sm:text-sm max-sm:text-[13px]">
          <h2 className="mb-6 cursor-default text-[15px] font-semibold text-white">
            Quick Links
          </h2>
          <div className="gray-text space-y-1">
            {isLoading === false ? (
              <>
                <p
                  className="mb-1 cursor-pointer transition-colors hover:text-white"
                  onClick={() => openInNewWindow(RouteName.TermsAndConditions)}
                >
                  {customPage && customPage[0]}
                </p>
                <p
                  className="mb-1 cursor-pointer transition-colors hover:text-white"
                  onClick={() => openInNewWindow(RouteName.PrivacyPolicy)}
                >
                  {customPage && customPage[2]}
                </p>
                <p
                  className="mb-1 cursor-pointer transition-colors hover:text-white"
                  onClick={() => openInNewWindow(RouteName.DMCA)}
                >
                  {customPage && customPage[1]}
                </p>
                <p
                  className="mb-1 cursor-pointer transition-colors hover:text-white"
                  onClick={() =>
                    openInNewWindow(RouteName.CookiesAndPersonalData)
                  }
                >
                  {customPage && customPage[4]}
                </p>

                <div>
                  <a
                    className="mb-1 cursor-pointer transition-colors hover:text-white"
                    href="https://news.ayozat.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    AYO NEWS
                  </a>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>

        {/* Contact us */}
        <div className="mb-6 text-xs sm:text-sm max-sm:text-[13px]">
          <h2 className="mb-6 cursor-default text-[15px] font-semibold text-white">
            Contact us
          </h2>
          <div className="gray-text">
            <a
              className="mb-3 flex items-center transition-colors hover:text-white"
              href="mailto:support@ayozathelp.com"
            >
              <div className="w-[30px]">
                <HiOutlineMail size={20} className="red-text mr-3 text-[20px]" />
              </div>
              support@ayozathelp.com
            </a>
            <div className="mb-1 flex">
              <div className="w-[30px]">
                <HiOutlineLocationMarker className="red-text mr-3 text-[20px]" />
              </div>
              <div className="block cursor-default leading-relaxed">
                <p className="mb-1">Building 3 Chiswick Park,</p>
                <p className="mb-1">566 Chiswick Park High Road,</p>
                <p className="mb-1">London, W4 5YA, United Kingdom</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="border-white/10" />
      {/* bottom section */}
      <div className="gray-text mb-5 mt-5 flex flex-wrap items-center justify-between gap-3 text-xs md:text-sm max-sm:flex-col max-sm:gap-2 max-sm:text-center">
        <div className="flex items-center gap-2">
          <FaRegCopyright />
          <span>
            AYOZAT {new Date().getFullYear()} - All Rights Reserved
          </span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-1.5">
          <span>Powered with</span>
          <AiFillHeart className="text-[15px] text-red-600" />
          <span>by</span>
          <a
            href="https://ayozat.co.uk/ayozat-tlc"
            target="_blank"
            className="font-semibold whitespace-nowrap text-white/90 transition-colors hover:text-white"
            rel="noreferrer"
          >
            AYOZAT MEDIA ECOSYSTEM
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;